"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oscar = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Turmoil_1 = require("../../turmoil/Turmoil");
class Oscar extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.OSCAR,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L15',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plus().influence(1);
                    b.br.br;
                    b.opgArrow().chairman();
                }),
                description: 'You have +1 influence. Once per game, replace the Chairman with one of your delegates from the reserve.',
            },
        });
        this.isDisabled = false;
    }
    play(player) {
        const turmoil = player.game.turmoil;
        if (turmoil)
            turmoil.addInfluenceBonus(player);
        return undefined;
    }
    canAct(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        return turmoil.hasAvailableDelegates(player.id) && this.isDisabled === false;
    }
    action(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        turmoil.delegateReserve.push(turmoil.chairman);
        turmoil.chairman = player.id;
        const index = turmoil.delegateReserve.indexOf(player.id);
        if (index > -1)
            turmoil.delegateReserve.splice(index, 1);
        this.isDisabled = true;
        return undefined;
    }
}
exports.Oscar = Oscar;
//# sourceMappingURL=Oscar.js.map